"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildFeatureSegment = exports.buildFeatureStateModel = exports.buildFeatureModel = void 0;
var models_1 = require("./models");
function buildFeatureModel(featuresModelJSON) {
    return new models_1.FeatureModel(featuresModelJSON.id, featuresModelJSON.name, featuresModelJSON.type);
}
exports.buildFeatureModel = buildFeatureModel;
function buildFeatureStateModel(featuresStateModelJSON) {
    var featureStateModel = new models_1.FeatureStateModel(buildFeatureModel(featuresStateModelJSON.feature), featuresStateModelJSON.enabled, featuresStateModelJSON.django_id, featuresStateModelJSON.feature_state_value, featuresStateModelJSON.featurestate_uuid);
    featureStateModel.featureSegment = featuresStateModelJSON.feature_segment ?
        buildFeatureSegment(featuresStateModelJSON.feature_segment) :
        undefined;
    var multivariateFeatureStateValues = featuresStateModelJSON.multivariate_feature_state_values
        ? featuresStateModelJSON.multivariate_feature_state_values.map(function (fsv) {
            var featureOption = new models_1.MultivariateFeatureOptionModel(fsv.multivariate_feature_option.value, fsv.multivariate_feature_option.id);
            return new models_1.MultivariateFeatureStateValueModel(featureOption, fsv.percentage_allocation, fsv.id, fsv.mv_fs_value_uuid);
        })
        : [];
    featureStateModel.multivariateFeatureStateValues = multivariateFeatureStateValues;
    return featureStateModel;
}
exports.buildFeatureStateModel = buildFeatureStateModel;
function buildFeatureSegment(featureSegmentJSON) {
    return new models_1.FeatureSegment(featureSegmentJSON.priority);
}
exports.buildFeatureSegment = buildFeatureSegment;
